<template>
  <div :class="classObject">
    <div
      class="border-item"
      @click="buttonClick"
    >
      <div class="name-bet" :class="classIsHighlight">
        <span v-if="isShowRate" >1:{{ rate }}</span>
      </div>
      <div class="money-bet">
        {{ $t('bet') }}: {{ totalBet }}
      </div>
    </div>
    <ChipBlock :value="totalQueueBet" />
    <ChipBlock class="success" :value="totalBet" />
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import ChipBlock from '@components/baccarat/buttons/chip-block.vue';
// eslint-disable-next-line no-unused-vars
import { GAMESTATE, BET_ERROR_STATUS } from '@config/constants.js';

export default {
  components: {
    ChipBlock
  },
  props: {
    gameName: { type: String, default: "" },
    resultType: { type: String, default: "" },
    result: { type: String, default: "" },
    rate: { type: Number, default: 0 },
    isShowRate: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default
      default: true
    },
    isHighlight: Boolean,
    id: { type: String, default: "" },
    betType: { type: String, default: "" },
    table: { type: String, default: "" },
    tableId: { type: String, default: "" },
    round: { type: Number, default: 0 },
    data: { type: Object, default: () => ({})},
    css: { type: String, default: "" },
    currentChip: { type: Number, default: 0 },
    gameState: {
      type: String,
      default: GAMESTATE.WAITING_NEW_GAME,
    },
  },
  computed: {
    ...mapState('user', ['limit', 'token']),
    ...mapState('bet', ['dialogs']),
    ...mapState('taixiu', ['taixiu77']),
    min: function() {
      return this.data.min;
    },
    max: function() {
      let maxBet = 0;
      for (const [, value] of Object.entries(this.taixiu77.bettingQueueValue)) {
        maxBet += value;
      }
      let max = this.limit - maxBet;
      if(max > this.data.max) max = this.data.max;
      if(max < this.data.min) max = -1; // money is not enough
      return max;
    },
    classObject: function () {
      return {
        'playbox-option-selected': this.dialogs[this.buttonId] === this.buttonId
      }
    },
    classIsHighlight: function () {
      return {
        'hightlight-animation': this.isHighlight
      }
    },
    showRate: function(){
      return this.rate !== undefined ? this.rate.toFixed(2) : "";
    },
    buttonId: function() {
      return `${this.table}_${this.betType}`;
    },
    totalBet: function() {
      let value = this.data.bettingValue[this.buttonId];
      if(value === "" || value === undefined) {
        value = 0;
      }
      return value;
    },
    totalQueueBet: function() {
      let value = this.data.bettingQueueValue[this.buttonId];
      if(value === "" || value === undefined) {
        value = 0;
      }
      return value;
    },
    
  },
  methods: {
    ...mapActions('bet', ['showBetDialog']),
    ...mapActions('taixiu', ['callBetting', 'clearBetValue', 'addToBetQueue']),
    buttonClick(e) {
      if(this.gameState !== 'BETTING') return;

      if(this.token === "" || this.token === undefined || this.token === null){
        this.$bvModal.show('modal-unauthorization');
      }
      else if(this.max < this.data.min){
        // console.log('max < min');
        this.$bvModal.show('modal-unbalance');
      }
      else {
        let val = isNaN(parseInt(this.currentChip)) ? 0 : parseInt(this.currentChip);
        // console.info('bet', val, this.currentChip);

        // eslint-disable-next-line no-unused-vars
        let errorMsg = "";

        if(val === 0) {
          // console.log('max:', val, this.max, this.data.min, this.data.max);
          val = this.max;
        }
        
        // check min
        if(val < this.min && val !== 0){
          val = this.min;
          errorMsg = BET_ERROR_STATUS.MIN;
        }

        // check max bet
        const totalBet = val +  this.totalQueueBet;
        if(totalBet > this.data.max){
          console.log('check max 1', val, this.totalQueueBet, totalBet, this.data.max);
          this.$bvModal.show('modal-maxbet');
          return;
        }

        // check max bet
        if(val > this.max){
          console.log('check max 2', val, totalBet, this.max);
          this.$bvModal.show('modal-unbalance');
          return;
        }

        // money is not enough
        if(this.max <= 0){
          this.$bvModal.show('modal-unbalance');
          return;
        }

        this.bettingStatus = "BETTING";
        const betValue = {
          roundId: this.round,
          betType: this.betType,
          amount: val,
          bettingId: this.buttonId,
          table: this.table
        }
        console.log('[base-button][buttonClick]', betValue);
        this.addToBetQueue(betValue);
      }
    },
  },
}
</script>

<style>

</style>
